import { render, staticRenderFns } from "./productComponents.vue?vue&type=template&id=6dc27098&"
import script from "./productComponents.vue?vue&type=script&lang=js&"
export * from "./productComponents.vue?vue&type=script&lang=js&"
import style0 from "./productComponents.vue?vue&type=style&index=0&id=6dc27098&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports